package es.subastia.domain.model

enum class AuctionProcedureType(val label: String, val colorHex: Long) {
    // Exact DB Types w/ Categorized Colors
    JUDICIAL_APREMIO("JUDICIAL EN VÍA DE APREMIO", 0xFF1E88E5), // Blue
    JUDICIAL_CONCURSAL("JUDICIAL CONCURSAL", 0xFFFB8C00), // Orange (Concursal distinct)
    JUDICIAL_VOLUNTARIA("JUDICIAL VOLUNTARIA", 0xFF1E88E5), // Blue
    NOTARIAL_HIPOTECARIA("NOTARIAL HIPOTECARIA", 0xFF43A047), // Green
    NOTARIAL_OTRAS("OTRAS SUBASTAS NOTARIALES", 0xFF43A047), // Green
    ADMINISTRATIVA_GENERAL("ADMINISTRATIVA GENERAL", 0xFF8E24AA), // Purple
    RECAUDACION_TRIBUTARIA("RECAUDACIÓN TRIBUTARIA", 0xFFE53935), // Red
    UNKNOWN("SUBASTA", 0xFF757575); // Grey

    companion object {
        fun fromString(text: String?): AuctionProcedureType {
            if (text.isNullOrBlank()) return UNKNOWN
            val normalized = text.uppercase().trim()
            return entries.find { it.label == normalized } ?: UNKNOWN
        }
    }
}
